import { Link } from "react-router-dom";
import { ArrowLeftIcon, ArrowRightIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { ChapterDetail } from "@/types/book";

export function ChapterNav({
  bookId,
  chapters,
  currentOrder,
}: {
  bookId: number;
  chapters: ChapterDetail[];
  currentOrder: number;
}) {
  const prevChapter = chapters.find((ch) => ch.order === currentOrder - 1);
  const nextChapter = chapters.find((ch) => ch.order === currentOrder + 1);

  return (
    <div className="flex flex-col sm:flex-row justify-between items-stretch sm:items-center gap-3 pt-2">
      {prevChapter ? (
        <Link to={`/books/${bookId}/chapters/${prevChapter.order}`}>
          <Button
            variant="outline"
            size="lg"
            className="w-full sm:w-auto"
          >
            <ArrowLeftIcon className="size-4" />
            <span className="truncate max-w-[200px]">
              Ch {prevChapter.order}: {prevChapter.title}
            </span>
          </Button>
        </Link>
      ) : (
        <div className="hidden sm:block" />
      )}

      {nextChapter ? (
        <Link to={`/books/${bookId}/chapters/${nextChapter.order}`}>
          <Button
            variant="outline"
            size="lg"
            className="w-full sm:w-auto"
          >
            <span className="truncate max-w-[200px]">
              Ch {nextChapter.order}: {nextChapter.title}
            </span>
            <ArrowRightIcon className="size-4" />
          </Button>
        </Link>
      ) : (
        <Link to={`/books/${bookId}`}>
          <Button size="lg" className="w-full sm:w-auto">
            Back to Book Overview
            <ArrowRightIcon className="size-4" />
          </Button>
        </Link>
      )}
    </div>
  );
}
